import { gql } from 'graphql-request'

export const BLUK_UPDATE_BOOK_CHAPTER = gql`
  mutation BulkUpdateBookChapter(
    $bulkUpdateBookChapterInput: BulkUpdateBookChapterInput!
  ) {
    bulkUpdateBookChapter(
      bulkUpdateBookChapterInput: $bulkUpdateBookChapterInput
    )
  }
`

export const BULK_UPDATE_BOOK_CHAPTER_CAMPAIGN = gql`
  mutation UpdateBookChapterCampaign(
    $updateBookChapterCampaignInput: UpdateBookChapterCampaignInput!
  ) {
    updateBookChapterCampaign(
      updateBookChapterCampaignInput: $updateBookChapterCampaignInput
    )
  }
`

export const BULK_REMOVE_BOOK_CHAPTER_CAMPAIGN = gql`
  mutation RemoveBookChapterCampaign(
    $removeBookChapterCampaignInput: RemoveBookChapterCampaignInput!
  ) {
    removeBookChapterCampaign(
      removeBookChapterCampaignInput: $removeBookChapterCampaignInput
    )
  }
`
